import React, { useReducer, useState } from "react";
import "./parent.scss";
import { Box, Divider, Skeleton, Tooltip } from "@mui/material";
import {
  AccountCircleRounded,
  Add,
  ArrowBackRounded,
  CancelRounded,
  CheckCircle,
  Person,
  PictureAsPdfRounded,
  Print,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import Delete from "../../../component/dialog/delete/Delete.tsx";
import SearchBar from "../../../component/searchBar/Search.tsx";
import UpdateParent from "./UpdateParent.tsx";
// import NewPersonnel from "./newPersonnel.tsx";
import { catchErrorApiCall } from "../../../_services/apiUtils.js";
import {
  domaineType,
  fonctionType,
  gradeType,
  ParentType,
  requestType,
} from "../../../types/GlobalType.ts";
import { API_PERSONNEL } from "../../../apiCaller/personnel.Caller.js";
import { accountService } from "../../../_services/accountServices.js";
import { orderBy } from "lodash";
import toast from "react-hot-toast";
import { parentContext } from "../../../context/AppContext.js";
import { API_CONFIG } from "../../../apiCaller/configuration.Caller.js";
import { API_PARENT } from "../../../apiCaller/perent.Callerl.js";
import SingleParent from "./singleParent.tsx";
import ConnexionErrorDiv from "../../../component/nodata/ConnexionErrorDiv.js";
import NewParent from "./newParent.tsx";

const Parent = () => {
  const [openAdd, setOpenAdd] = React.useState<boolean>(false);

  const [openArchiveParent, setopenArchivePersonnel] =
    React.useState<Boolean>(false);

  const [openActivateParent, setopenActivatePersonnel] =
    React.useState<Boolean>(false);

  const [itemId, setItemId] = useState<string | number>();

  const [loadingDeleteBtn, setLoadingDeleteBtn] =
    React.useState<boolean>(false);

  const [dataPersonnel, setDataPersonnel] = useState<ParentType[]>([]);
  const [dataFonction, setDataFonction] = useState<fonctionType[]>([]);
  const [dataGrade, setDataGrade] = useState<gradeType[]>([]);
  const [dataDomaine, setDataDomaine] = useState<domaineType[]>([]);

  const [singleDataParent, setsingleDataParent] = useState<ParentType>();
  // console.log(singleDataParent);
  const [stateReload, dispatchReload] = useReducer((x) => x + 1, 0);

  // const [openAdd, setOpenAdd] = useState<Boolean>(false);
  const [openSingle, setOpenSingle] = useState<Boolean>(false);
  const [openUpdate, setOpenUpdate] = useState<Boolean>(false);
  const [searchValue, setsearchValue] = useState<string>("");

  const navigate = useNavigate();

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const fetchAllParents = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      const response = await API_PARENT.PARENT.getAll(token);
      setDataPersonnel(response.data.data);

      setState({ ...state, isLoading: false });
    } catch (error) {
      setState({ ...state, isLoading: false });

      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }

      catchErrorApiCall(error);
    }
  };

  const handleActivateParent = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      await API_PARENT.PARENT.active(id, token);
      setLoadingDeleteBtn(false);
      setopenActivatePersonnel(false);
      dispatchReload();
      toast.success("Parent activé avec succes", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      setLoadingDeleteBtn(false);
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };
  const handleArchiveParent = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      let response = await API_PARENT.PARENT.desactive(id, token);
      setLoadingDeleteBtn(false);
      setopenArchivePersonnel(false);
      dispatchReload();
      toast.success("Parent archivé avec succès", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      console.log(error);
      setLoadingDeleteBtn(false);

      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }

      catchErrorApiCall(error);
    }
  };

  let sortedData: ParentType[] = [];
  if (dataPersonnel.length > 0) {
    sortedData = orderBy(dataPersonnel, ["nom"], ["asc"]);
  }

  const skeletonHeader = (
    <div className="configuration_">
      <Skeleton
        variant="rounded"
        height={25}
        width={250}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
      <Skeleton
        variant="rounded"
        height={25}
        width={150}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
    </div>
  );
  const skeletonSearchSection = (
    <div className="input-container">
      <Skeleton
        variant="rounded"
        height={30}
        width={250}
        sx={{ marginTop: "5px" }}
      />

      <div className="right_list_part">
        <Skeleton
          variant="rounded"
          height={30}
          width={"90%"}
          sx={{ marginTop: "5px" }}
        />
        <Skeleton
          variant="circular"
          height={30}
          width={30}
          sx={{ marginTop: "5px" }}
        />
      </div>
    </div>
  );
  const skeletonTable = (
    <Skeleton
      sx={{ marginTop: "10px" }}
      variant="rounded"
      height={500}
      width={"100%"}
    />
  );

  React.useEffect(() => {
    fetchAllParents();
    // fetchAllFonction();
    // fetchAllGrade();
    // fetchAllDomaine();
  }, [stateReload]);

  return (
    <>
      {state.errorMessage === "ERR_NETWORK" ? (
        <ConnexionErrorDiv />
      ) : (
        <Box
          bgcolor="#eee"
          flex={5}
          p={1}
          sx={{ marginLeft: "200px", marginTop: "66px" }}
        >
          {state.isLoading ? (
            skeletonHeader
          ) : (
            <div className="configuration_">
              <div className="homeMenuCong">
                {/* <Link to="/" style={{ marginTop: "5px" }}> */}
                <ArrowBackRounded
                  sx={{
                    color: "#0091EA",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    mt: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/configuration/configuration")}
                />
                {/* </Link> */}
                <div className="homeTitleItem">
                  <span className="homeTitle"> Configuration</span>
                </div>
                <div className="homeTitleItem">
                  <Person sx={{ color: "#1565C0", mr: "10px" }} />
                  <span className="homeTitleSmall">Parent </span>
                </div>
              </div>
              <div className="right__">
                {/* <button
              className="add_button_pers"
              onClick={() => setOpenAdd(true)}
            >
              <Tooltip title="Nouveau élève">
                <PersonAddAlt1 className="ico" />
              </Tooltip>
              Nouveau
            </button> */}
                <button className="add_button_pers">
                  <Tooltip title="Exporter PDF">
                    <PictureAsPdfRounded className="ico" />
                  </Tooltip>
                  exporter
                </button>
              </div>
            </div>
          )}

          <Divider sx={{ marginTop: "5px", marginBottom: "10px" }} />

          <div className="card_Classe">
            {state.isLoading ? (
              skeletonSearchSection
            ) : (
              <div className="input-container">
                <h2 className="card-title">Liste</h2>
                <div className="right_list_part">
                  <SearchBar
                    searchValue={searchValue}
                    setSearchValue={setsearchValue}
                    label="Rechercher..."
                  />
                  <button
                    className="add_button_pers"
                    onClick={() => setOpenAdd(true)}
                  >
                    <Tooltip title="Nouveau">
                      <Add className="ico" />
                    </Tooltip>
                  </button>
                  <button className="add_button_pers">
                    <Tooltip title="Imprimer">
                      <Print className="ico" />
                    </Tooltip>
                  </button>
                </div>
              </div>
            )}

            {state.isLoading ? (
              skeletonTable
            ) : (
              <div className="table_component" role="region">
                <table>
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Noms</th>
                      <th>Téléphone</th>
                      <th>Adresse</th>
                      <th className="headerSection">Status</th>
                      <th className="actionHeader"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedData
                      .filter(
                        (value) =>
                          value.nom
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()) ||
                          value.postnom
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()) ||
                          value.prenom
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()) ||
                          value.telephone
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()),
                      )
                      .map((item, index) => {
                        return (
                          <tr key={index}>
                            <td
                              onClick={() => {
                                setsingleDataParent(item);
                                setOpenSingle(true);
                              }}
                            >
                              {index + 1}
                            </td>
                            <td
                              className="userName"
                              onClick={() => {
                                setsingleDataParent(item);
                                setOpenSingle(true);
                              }}
                            >
                              <div className="userName">
                                <AccountCircleRounded />
                                {`${item.nom?.toUpperCase()} ${item.postnom?.toUpperCase()} ${item.prenom?.toUpperCase()}`}
                              </div>
                            </td>
                            <td
                              onClick={() => {
                                setsingleDataParent(item);
                                setOpenSingle(true);
                              }}
                            >
                              {item.telephone}
                            </td>
                            <td
                              onClick={() => {
                                setsingleDataParent(item);
                                setOpenSingle(true);
                              }}
                            >
                              {item.quartier.toUpperCase()}
                            </td>
                            <td className="statusSection">
                              <span>
                                {item.parent_status ? (
                                  <Tooltip title="Activé" placement="left">
                                    <CheckCircle
                                      style={{
                                        color: "#28a745",
                                        fontSize: "14px",
                                      }}
                                    />
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="Archivé" placement="left">
                                    <CancelRounded
                                      style={{
                                        color: "#7f1d18",
                                        fontSize: "14px",
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </span>
                            </td>
                            <td>
                              <div className="actionSection">
                                {item.parent_status ? (
                                  <span
                                    className="archiveP"
                                    onClick={() => {
                                      setItemId(item.parent_id);
                                      setopenArchivePersonnel(true);
                                    }}
                                  >
                                    Archiver
                                  </span>
                                ) : (
                                  <span
                                    className="archiveP"
                                    onClick={() => {
                                      setItemId(item.parent_id);
                                      setopenActivatePersonnel(true);
                                    }}
                                  >
                                    Activer
                                  </span>
                                )}

                                <span
                                  className="editP"
                                  onClick={() => {
                                    setsingleDataParent(item);
                                    setOpenUpdate(true);
                                  }}
                                >
                                  Editer
                                </span>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </Box>
      )}

      {openUpdate && (
        <UpdateParent
          setOpen={setOpenUpdate}
          data={singleDataParent}
          dataFonction={dataFonction}
          dataGrade={dataGrade}
          dataDomaine={dataDomaine}
          dispatchReload={dispatchReload}
        />
      )}
      {openAdd && (
        <NewParent setOpen={setOpenAdd} dispatchReload={dispatchReload} />
      )}

      {openSingle && (
        <parentContext.Provider value={singleDataParent}>
          <SingleParent setOpen={setOpenSingle} />
        </parentContext.Provider>
      )}

      {openActivateParent && (
        <Delete
          setOpen={setopenActivatePersonnel}
          itemId={itemId}
          label={"Voulez-vous vraiment activer ce parent?"}
          handleDelete={handleActivateParent}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
          title="Activation"
        />
      )}
      {openArchiveParent && (
        <Delete
          setOpen={setopenArchivePersonnel}
          itemId={itemId}
          label={"Voulez-vous vraiment archiver ce parent?"}
          handleDelete={handleArchiveParent}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
          title="Archivage"
        />
      )}
    </>
  );
};

export default Parent;
